export const STATUS_READY = 'STATUS_READY';
export const STATUS_WAITING = 'STATUS_WAITING';
export const STATUS_SUCCESS = 'STATUS_SUCCESS';
export const STATUS_FAILURE = 'STATUS_FAILURE';
